import React, { useState } from "react";
import {
  notification,
  QRCode,
  Card,
  Button,
  Segmented,
  Space,
  Form,
  Input,
  Flex,
  Divider,
  Alert,
} from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import useCreate from "hooks/useCreate";
import useFormErrors from "hooks/useFormErrors";
import { useAuth } from "context/providers/auth";
import { slug_regexp } from "helpers/regexp";

function download(url, fileName) {
  const a = document.createElement("a");
  a.download = fileName;
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

const downloadPngQRCode = () => {
  var _a;
  const canvas =
    (_a = document.getElementById("qr_download")) === null || _a === void 0
      ? void 0
      : _a.querySelector("canvas");
  if (canvas) {
    const url = canvas.toDataURL();
    download(url, "qr.png");
  }
};

const downloadSvgCode = () => {
  var _a;
  const svg =
    (_a = document.getElementById("qr_download")) === null || _a === void 0
      ? void 0
      : _a.querySelector("svg");
  const svgData = new XMLSerializer().serializeToString(svg);
  const blob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  download(url, "qr.svg");
};

const CompanyQrCode = () => {
  const {
    state: {
      user: { company: data },
    },
    updateCompany,
  } = useAuth();

  const [render_type, setRenderType] = useState("png");
  const [form] = Form.useForm();
  const { pristine, has_error, onFieldsChange, reset } = useFormErrors(data);

  const path = "/companies";

  const { is_saving, create } = useCreate({
    path,
    form,
    success_message: "Zaktualizowano dane firmy",
    onSuccess: (company_data) => {
      updateCompany(company_data);
      reset();
    },
  });
  return (
    <Card
      title="Kod QR"
      className="m-t-20"
      extra={
        <Space>
          <Button
            type="primary"
            htmlType="button"
            disabled={!pristine || has_error}
            onClick={
              render_type === "png" ? downloadPngQRCode : downloadSvgCode
            }
          >
            Pobierz
          </Button>
        </Space>
      }
    >
      <Alert
        style={{ marginBottom: 20 }}
        showIcon
        type="info"
        message="Kod QR zawiera link do formularza publicznego"
      />
      <Form
        form={form}
        layout="vertical"
        onFieldsChange={onFieldsChange}
        initialValues={{
          slug: data?.slug,
        }}
        onFinish={(values) => create(values)}
      >
        <Form.Item
          label="Unikalny link"
          name="slug"
          required
          tooltip="Unikalny link do formularza publicznego"
          hasFeedback
          rules={[
            {
              pattern: slug_regexp,
              message:
                "Pole może zawierać tylko małe litery (bez polskich znaków), cyfry i myślniki",
            },
          ]}
        >
          <Input
            placeholder="Slug firmy"
            maxLength={128}
            addonBefore="https://evertask.pl/"
            addonAfter="/zgloszenia"
          />
        </Form.Item>
        <p style={{ margin: "0 0 8px" }}>Wybierz format</p>
        <Segmented
          options={["png", "svg"]}
          value={render_type}
          onChange={setRenderType}
        />
        <div
          style={{
            margin: "20px 0",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <QRCode
            type={render_type === "png" ? "canvas" : render_type}
            errorLevel="Q"
            status={is_saving ? "loading" : "active"}
            size={220}
            iconSize={40}
            value={`https://evertask.pl/${data.slug}/zgloszenia`}
            icon="data:image/png;base64,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"
          />
        </div>
        <div style={{ display: "none" }}>
          <div id="qr_download">
            <QRCode
              type={render_type === "png" ? "canvas" : render_type}
              errorLevel="Q"
              status={is_saving ? "loading" : "active"}
              value={`https://evertask.pl/${data.slug}/zgloszenia`}
              icon="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAACXCAYAAAAGVvnKAAABU2lDQ1BJQ0MgUHJvZmlsZQAAGJV1kDFLQmEUhh9LESrSIGhpMAgqsEirrUUdIogSLcq269W0ULtdb0TQD+gHRFNb1OwSLhERTQ5BFAb9gKCpQXApuZ2rlVp04OU8vLx8vN+BDhRNy9iBbM7QI3NBz1ps3eN8xUEfLnoZUtS8FgiHFyTC926fahmbtR/GrbcuS6W3rYtCZZaBo9Ozu/u/+bbpSiTzquwP0aiq6QbYhoXDe4ZmsYh+XUoJH1qcavCJxfEGF+qZ5UhI+FbYraaVhPCjsDfe4qdaOJvZVb86WO17krmVqLVFg0QJ4mcaH7F/ctP1XIhtNPbR2SRFGgMPAXE0MiSF58mhMoFX2M+kaMa67++7NT3lAHyrAi9NL7cIV0vgKje9Eenplr/f7GiKrvxc01a15zem/A3uLoLj2DQr8p5zDGpPpvleNM3aOXQ+w3X1E7f5Y1Vduo26AAAAVmVYSWZNTQAqAAAACAABh2kABAAAAAEAAAAaAAAAAAADkoYABwAAABIAAABEoAIABAAAAAEAAACZoAMABAAAAAEAAACXAAAAAEFTQ0lJAAAAU2NyZWVuc2hvdF2+ZHkAAAHWaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA2LjAuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjE1MTwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj4xNTM8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpVc2VyQ29tbWVudD5TY3JlZW5zaG90PC9leGlmOlVzZXJDb21tZW50PgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KstW6ZwAACSpJREFUeAHtnVGOIzUURdMtNgFLAKk/YJofBCtgD4wUzcfAeqAlULdmD8wqmIGPlmYLsIwmtxN3HMdVZafs52e/W9JMqlwVl319cv3qVSV99d0P3z9tuFCBigpcPe2WivW3qfq/D/vz4vXfv07b4PadlnKrhgLf/LLZfP3z5rMadYvXCXAcUIRIXP6lE/bpZA6kv3/dw7XUS+5vo8CbT8/n7cfJCFYbUC496+e3L+/UDxngomO9DFg3K198+9JUvZARrpdB6nJFtZMRri6ZOmu0SsgI19k4dVuA1IW3tJ8uCZc3HGOutoXsn9/2Qf2Y2trtlTdVQoQ2kMG93r+2Owij97w5ZIALkHEZU4EgHkMn5ZyM7jUmVAm9krmtxNgrYSgGOeRwK8nvTX0n4/To6z32emSqRIfrQcbUxNhAZfSuDmSMvzKGYJBDD8+OxXpTHjLGXzGdxy8L0hZ+h6/9jdXrBGy1hF1WABcTgYyAdcnH6kYDrt0j1nNLmRQGAZvTeOx9kZRF2OH1MRkBCzW1sQ0Hm0hZhAKsg4yAhXra2AZgP75L7uvlkBGwZJGHOnAmVTHVz8sgc4nWqVpZPp4CbnrEa+ZyWeD/x1eZp+Hh3SqwAi7X53wnwzTJZTwFfIfCN42w7Zet6HEeZD3GYRDKieaEKiSeq46v8wqkQ9YTYIBoIQs9Lwv3llQgPSbTHocRrJJcFK0rzck0x2GEqygQNSpbhkzrNEm4avBQpc7l6VLjNIlsMyDj0oUC806mbZoEWBm3M7oYAQONnIZM2zR5we0MA+PXRRenIdPUfDc1anNWaLTwLNXHjx83Hz7IfM/09vZ28+rVK00j99yWeEymzcXUyXZoUML0vd1uxSB7fHxUqVT88evwx3xVNl1Bo7wfeptqjaSLTbWhdfk5ZHAxPGXBZVkBN41PHHl3dzexp3yxxmnS9fIcMvx0Jpc0BRYgS6tk/KNOIdMYWGsdg4RHjxH0Sy1v376VOlX2eU4hy3473zCnAOOxvTqnkHGqnGPmdN9C6oLx2FGuI2ScKo+qdLaG/Jjm5Zgn03iPUqtyCXcfbm5uxFqvNT/mBNg7GVMWTo/uXjUH/E5MQuaUyHlVFI/lNLvVsXvIGPCn668sN9aPk6VLzCMTbiVJXln2MCDXG15V5o3TwlTJBOy5nMcUxvk+loQKJGT5pRKwYdM0b1+f/flkza3toG10svNBuuYTF+eiREsScmN4n5STaU/A+hpyuvTVmFtPuKqUDPg1P9oTykjIQkVi23CxBMhib2XZZkPIlihInCZRDeOxuJiELK7LvhTutZCy8N/OeMxX47jex7eVju2VW8twMDSK8dj00NDJYtpkAharomZZT1eW0OHq6fcvn2oK0lXdmB4vDPL5aM/0SHO6hDYr4JqWts6eHm6Ihz23CxnAcr/AiPUVi2Q8tqKZzd4qBxmmoZaLD5K/3rJNF5ybTjYnWkYqYK4ajfvoZPOjInd1Oegj3kzAzgOGvYRsWaPZI6QSsLONUL5TDrJBH/Gmky0TLgcZ2jLgU7hSTtZbAtZHTxYyuNlAoEkG/D092uMDhnVZyHDGwUBDlySWnp1MLk/mjwRAwz8/d4bcVWf5K8l4rGcnu3r686cnPoLtfwIO6wk3ySXvV0ZaWKUIyd7SCd/rEzep0uxOK11IHkvGY50q+NJs+Zjs5dSKV/xpXHEzazSttIuhjdfPcVBnsVANcU/qXHAxHDuik9W6uNg7meFP7glc2EjQYkTA0PVaFxd7yOhk0Hi/GHUxdL6uk+EMBM20iwGBuk6GMyRMEzhs2AX9T3CxUftfI+B3Wh2vLuFkVt0M/U4ADLHYqPGYA6LG6xEy1G7xz/wBsMR+jwxYrXgMWJ1ChhJr0yYBw6hXi8dQ9zlkmDYsTJvo45tP0CBpGdnFasZjEPccMpSO7mboX6KDQY6RAUP/ai54iOD4O/7hmfBM/vvXYWn/24Arw6kB2OiQ1fw7AIAs7mRACQMxkqOhL5geCdiJUdSeKnGy+efJ3GU9nv3qdQFcrh8ZfbDgYBlyrDp0HjJU7QaoJ9CcC2e4lq8iLH70KRL9hYu1dzKnvGbQHEhuanfbru2Zr5YcrGZuzMmOW1XLTuaOBmgrB9BVtfq1UjssAQYHq3WvMhzf6avL8MjBty0BBge7v78XG1HzkLn4S+r7k2IjO3OimimL2GnTp8vYuzsuswgXHEwi0A+xMAmZpanRDbj0FOnOi1czkFl0LjfQUqkKd77wdXjILMPlpkepq8gQLrc9FGQACgumQyyWgvnnDh/+0wKXa1O3kDmQ0BEHlzWoAJNbXEDf2rVce/xX8ykMX4xwXfICoXXcFPa95Pb0Uxglz8K6TCtAJ5sZfskfVJFOkM50u/guOllxSfMr9GOr/Hfrfwchmxgj/8Ji4pBixRqD9WKd21VEyEqqeWFdozsZY7IJMBiPTQhzQTGdLCKay7tFdhUvcvmt4hUrqpCQRQbDWlI3IkHRIkJWVM78yiw4GWOyCBeMxyKirCiikwXiMR4LBCmwScgCERmPBYIU2CRkgYh0skCQApuELBBRyslGT8D6shIyTw3eSvLEKLhKyAqKmVOVJSdjCsMjg6kLT4yCq3SygmKmVmXJxaAJITuQwXgs9SOSfxwhy9ds9TusORljsgMyjMdWf3YmK6CT7aRhAnaSjyI7CNlORqkEbJER67ASTpe7QdtutyZBk/quJ53MsJNJXYCYh0wyHtM200l9S8o8ZFbjMckncs1Dps1dRmyPecisTpd0MsGPs9XpUlBi3ruUusKSHNSlc0m6GNpifrpcGhDuX68AIVuvYXc10Mm6G7K+GtwiPDDvZFIJSS0otuivechafLK1ACfVDt4g3ylt6QZ5i58NNe9kUp9mDedp5dqEbDf60ldbrYBrEY+hr4RsJwLEtwBaKydjTObZiuRz/t5pxVZbxGPoHJ3MG+KHhwdva6zVlk5NyDyWMG22mlK8Zgy3yukyMqQjpjRaTZWQl04WgQx/BJ6OFhHmwiJCNiHcSKC1jMcgLyGbgAzFAK31AM00r5tdjMkSh0ryb18mNin5sJbxGBpJJ0scKjgaUhy9OZuG2JJOlghZeJj/U1P4MorW7wrgQ9H6g0HIQnq4XVyB/wHXfsFk/yry3QAAAABJRU5ErkJggg=="
              color="#000000"
              bgColor="#ffffff"
              iconSize={40}
              size={220}
            />
          </div>
        </div>
        <Divider size="medium" />
        <Flex justify="flex-end">
          <Space>
            <Button
              disabled={pristine || has_error}
              loading={is_saving}
              type="primary"
              htmlType="submit"
            >
              Zapisz
            </Button>
            <CopyToClipboard
              text={`https://evertask.pl/${data.slug}/zgloszenia`}
              onCopy={() =>
                notification.success({
                  message: "Skopiowano pomyślnie.",
                })
              }
            >
              <Button
                type="primary"
                disabled={!pristine || has_error}
                style={
                  !pristine || has_error
                    ? {}
                    : { backgroundColor: "rgb(22, 119, 255)" }
                }
              >
                Kopiuj link
              </Button>
            </CopyToClipboard>
          </Space>
        </Flex>
      </Form>
    </Card>
  );
};

export default CompanyQrCode;
